import { useRef, useState } from "react";
import { Loader2, Paperclip, X } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";
import { newKey } from "../lib/procurement";
import { Button } from "./ui/button";
import { Label } from "./ui/label";

const ACCEPT = "application/pdf,image/jpeg,image/png,image/webp";

// A private file sent to POST /files for the module that owns `context`, then attached by that module's own write (never public).
// `files` is the list [{ id, name }] the parent keeps; the module decides who may read them afterwards.
export default function PrivateFilesField({ context, label = "Document (PDF ou image)", files, setFiles, max = 5, testid = "files-add" }) {
  const [uploading, setUploading] = useState(false);
  const input = useRef(null);
  const upload = async (picked) => {
    if (!picked.length) return;
    setUploading(true);
    try {
      for (const file of picked) {
        const form = new FormData();
        form.append("file", file);
        const { data } = await api.post("/files", form, { params: { context }, headers: { "Idempotency-Key": newKey() } });
        setFiles((list) => [...list, { id: data.id, name: data.name || file.name }]);
      }
    } catch (e) {
      const detail = e?.response?.data?.detail;
      toast.error(detail?.msg || "Fichier refusé : PDF ou image (JPEG, PNG, WebP) de 10 Mo maximum.");
    } finally {
      setUploading(false);
      if (input.current) input.current.value = "";
    }
  };
  return (
    <div className="space-y-1.5">
      <Label>{label}</Label>
      <div className="flex flex-wrap items-center gap-2">
        {files.map((f) => (
          <span key={f.id} className="inline-flex items-center gap-1 rounded-md border border-slate-200 bg-slate-50 px-2 py-1 text-xs" data-testid="file-chip">
            <Paperclip size={12} />{f.name}
            <button type="button" aria-label={`Retirer ${f.name}`} onClick={() => setFiles((list) => list.filter((x) => x.id !== f.id))}><X size={12} /></button>
          </span>
        ))}
        <Button type="button" variant="outline" size="sm" onClick={() => input.current?.click()} disabled={uploading || files.length >= max} data-testid={testid}>
          {uploading ? <Loader2 size={14} className="mr-1.5 animate-spin" /> : <Paperclip size={14} className="mr-1.5" />}Joindre
        </Button>
        <input ref={input} type="file" className="hidden" accept={ACCEPT} multiple data-testid={`${testid}-input`} onChange={(e) => upload(Array.from(e.target.files || []))} />
      </div>
    </div>
  );
}
